
// 一种规格栏选取
function Banner() {
    // 一个轮播图片的宽度
    this.bannerWidth = 470;
    this.bannerGroup = $("#banner-group");
    this.index = 1;
    this.leftArrow = $(".left-arrow");
    this.rightArrow = $(".right-arrow");
    this.bannerUl = $("#banner-ul");
    this.pageControl = $(".page-control");
    // 获取子标签的li对象，来确定标签的个数, 可以得到LI标签的个数
    this.liList = this.bannerUl.children('li');
    // 确定banner-ul下面li标签的个数1
    this.bannerCount = this.liList.length;
    this.spuPrice = $('.pd-price-box').find('.regular-price').children('i').text();
}


Banner.prototype.initBanner = function () {
    // 复制第一张轮播图片对象
    var firstBanner = this.liList.eq(0).clone();
    // 复制最后一张轮播图片对象
    var lastBanner = this.liList.eq(this.bannerCount - 1).clone();
    // 把第一张图片对象添加到bannerUl里面的最后面
    this.bannerUl.append(firstBanner);
    // 把最后一张图片对象添加到bannerUl里面的最前面
    this.bannerUl.prepend(lastBanner);
    // 动态生成轮播图 UL标签（banner-ul）的宽度
    this.bannerUl.css({"width": this.bannerWidth * (this.bannerCount + 2), 'left': -this.bannerWidth});

}


// 轮播图函数
Banner.prototype.animate = function () {
    var self = this;
    // "left":  是bannerUl的CSS位置参数。通过这个移动标签
    //.stop() 用来防止动画叠加，不加的话，如果从当前轮播图切换到其他页面，再切换回来，轮播图就会跑的很快
    this.bannerUl.stop().animate({"left": -self.bannerWidth * this.index}, 0);
    // this.index: 总的轮播图片的下标（包含第一张和最后一张）（注：无限循环轮播排列中会把第一张复制后放到最后，同时复制最后一张放到最前面）
    var index = this.index;
    // index=0 表示第一张轮播图，其实是有效图片的最后那张（注：无限循环轮播排列中会把第一张复制后放到最后，同时复制最后一张放到最前面）
    if (index === 0) {
        // this.bannerCount：是有效轮播图的总数（也就是没有包含第一张和最后一张），和小点点的总数一样。
        // this.bannerCount-1 等于最后一个小圆点的下标
        index = this.bannerCount - 1;
        // this.bannerCount+1 等于总轮播图片最后一张的下标 （this.bannerCount 是有效图片的数量+2 = 总轮播图片），也就是有效图片的第一张
    } else if (index === this.bannerCount + 1) {
        // 第一个小点点的下标为 0
        index = 0;
    } else {
        index = this.index - 1;
    }
    // 获取轮播到当前图片所应的小圆点LI标签对象。 this.pageControl：是装所有小圆点的盒子，'li'：是小圆点
    var liTagObj = this.pageControl.children('li').eq(index);
    // 给当前对应的小圆点添加CLASS "active"， 其他几个同类的LI标签(兄弟元素)去掉CLASS "active"
    liTagObj.addClass("active").siblings().removeClass("active");
}

// PICTURE点击函数处理 Product Color Variation
//   ['red', '32', '2001', '1']: 'red':规格信息  '32':价格  '2001'：库存  '1'： SKU id
Banner.prototype.listenPageControl = function () {
    var self = this;
    //each：遍历self.pageControl标签下的所有LI标签。  object : 是指子标签 LI 本身
    self.pageControl.children("li").each(function (index, object) {
        $(object).click(function () {
            // 得到所点击小圆点的下标值
            self.index = index + 1;
             // 如果在已经被点击的颜色标签上在点击一下，标签被去除点击，价格 库存设置空，尺寸标签全亮 恢复可点击
            if($(object).hasClass("active")){
                $(object).removeClass("active");
                $('.pd-price-box').find('.regular-price').children('i').text(self.spuPrice);
                $('.pd-stock').find('span').children('i').text('');
                // 清空标签属性SKU ID
                $('.pd-add-sku-id').children('a').attr('data-sku-id', '');
                $(this).parents('ul').siblings('span').children('i').text('');
                return;
             }else{
                 // 轮播到对应的图片
                 self.animate();
            }

            // show color info
            // data type of data-color-desc  : ['red', '32', '2001', '1', 'picture url']
            var data = eval($(this).attr('data-color-desc'));
            // 把当前点击的颜色名称显示出来
            $(this).parents('ul').siblings('span').children('i').text(data[0]);
            // 把当前点击的PRICE显示出来
            $('.pd-price-box').find('.regular-price').children('i').text(data[1]);
            // 把当前点击的库存显示出来
            $('.pd-stock').find('span').children('i').text(data[2]);
            // 把SKU ID加到标签属性中
            $('.pd-add-sku-id').children('a').attr('data-sku-id', data[3]);

        });
    })
}


Banner.prototype.run = function () {
    this.initBanner();

    this.listenPageControl();
    // this.listenSizeTagClickEvent();
}






// run the code after whole page is loaded
$(function () {
    var banner = new Banner();
    banner.run();

})